export const GET_ROLES_LIST_REQUEST = "GET_ROLES_LIST_REQUEST";
export const GET_ROLES_LIST_FAILURE = "GET_ROLES_LIST_FAILURE";
export const GET_ROLES_LIST_SUCCESS = "GET_ROLES_LIST_SUCCESS";

